import { ReactElement } from 'react';

import { ReceptionServiceDuration } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';
import { InteractiveTable } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';

type ReceptionServiceInteractiveTableEstimatedDurationCellProps = {
   readonly estimatedDuration: ReceptionServiceDuration | undefined;
};

const t = receptionServiceTranslationKeys.extensions.calendar.appointment.table.cells;

export const ReceptionServiceInteractiveTableEstimatedDurationCell = (
   props: ReceptionServiceInteractiveTableEstimatedDurationCellProps
): ReactElement => {
   const translate = useTranslate();

   return (
      <InteractiveTable.Cell testId={'estimatedDuration'}>
         {props.estimatedDuration
            ? `${translate(
                 createInterpolatedTranslationKey(t.estimatedDuration, {
                    total: props.estimatedDuration.asMinutes(),
                 })
              )}`
            : '-'}
      </InteractiveTable.Cell>
   );
};
